/* tslint:disable */
export var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["UNKNOWN"] = 0] = "UNKNOWN";
    DeviceType[DeviceType["DESKTOP"] = 1] = "DESKTOP";
    DeviceType[DeviceType["IPAD"] = 2] = "IPAD";
    DeviceType[DeviceType["IPOD"] = 3] = "IPOD";
    DeviceType[DeviceType["IPHONE"] = 4] = "IPHONE";
    DeviceType[DeviceType["ANDROID_PHONE"] = 5] = "ANDROID_PHONE";
    DeviceType[DeviceType["WINDOWS_PHONE"] = 6] = "WINDOWS_PHONE";
    DeviceType[DeviceType["ANDROID_TABLET"] = 7] = "ANDROID_TABLET";
    DeviceType[DeviceType["WINDOWS_TABLET"] = 8] = "WINDOWS_TABLET";
    DeviceType[DeviceType["AMAZON_DEVICE"] = 9] = "AMAZON_DEVICE";
    DeviceType[DeviceType["APPLE_TV"] = 10] = "APPLE_TV";
})(DeviceType || (DeviceType = {}));
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/DeviceTypeEnum.ts
// module id = 544
// module chunks = 3